<template>
  <div class="product-wrapper">
    <div class="banner-container">
      <div class="banner-item">
        <img class="bg" src="../../assets/images/banner-bg.png"/>
        <div class="content">
          <div class="title">产品与服务</div>
          <div class="title">智慧医疗统一对账云平台</div>
          <div class="subtitle"></div>
          <div class="desc">
            还在为这些问题而烦恼吗？
            <br/>
            支付渠道、场景 众多且在不断增加；现金退款对现金储备量要求大；错账无法及时处理；每笔资金无法区分业务场景；
            <br/>
            智慧医疗统一对账管理平台为您提供一站式解决方案！
          </div>
        </div>
      </div>
    </div>
    <div class="body-container">
      <div class="intro-container bg-gray">
        <div class="intro-con">
          <div class="content content-about">
            <div class="about-left">
              <div class="image-single">
                <img src="../../assets/images/pay/pay-2.png"/>
              </div>
            </div>
            <div class="about-right">
              <div class="about-title">智慧医疗统一对账云平台</div>
              <div class="about-desc">
                提供更加创新、便捷的支付场景，为患者解决付费难的问题，从而帮助医院改善患者的医疗服务，帮助医院合理“关闭”收费
                <br/>
                在提高患者支付需求满意度同时，也要妥善解决财务管理部门面临的支付改革后遗症，资金认领难、银行回款单场景划分不清，出现单边账无法找到原因、 退款原路返回结算资金等等问题，有效防控财务金融风险，减轻财务工作负担
                <br/>
                从接口对接、资金保障、信息安全等多维度为信息科提供整体的 医疗支付解决方案，确保项目高效、稳定、安全落地
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="intro-container">
        <div class="intro-item">
          <div class="intro-con">
            <div class="title">一站式解决方案</div>
            <div class="subtitle">
              非医疗场景，无业务系统的收费我们都要“管起来”
              <br/>
              外部支付渠道增加，新的业务系统接入。 都“不受影响”
            </div>
            <div class="content">
              <div class="image-single">
                <img src="../../assets/images/pay/pay-1.png"/>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="intro-container bg-gray">
        <div class="intro-con">
          <div class="title">统一对账云平台优势</div>
          <div class="content content-box">
            <div class="box-con">
              <div class="box-item">
                <img class="box-image" src="../../assets/images/pay/merit-3.png"/>
                <div class="box-title">对账</div>
                <div class="box-desc">
                  1、自动获取对账数据；<br/>
                  2、自动对账；<br/>
                  3、分场景分渠道报表汇总；<br/>
                  4、错帐核销，防呆账；
                </div>
              </div>
            </div>
            <div class="box-con">
              <div class="box-item">
                <img class="box-image" src="../../assets/images/pay/merit-2.png"/>
                <div class="box-title">绿色平台</div>
                <div class="box-desc">
                  1、不改造现有系统，不影响现有系统运行；
                </div>
              </div>
            </div>
            <div class="box-con">
              <div class="box-item">
                <img class="box-image" src="../../assets/images/pay/merit-1.png"/>
                <div class="box-title">实施灵活</div>
                <div class="box-desc">
                  1、可分场景，渠道阶段性上线实施；<br/>
                  2、强大的适配能力，不依赖原有支付厂商即可完成数据接入
                </div>
              </div>
            </div>
            <div class="box-con">
              <div class="box-item">
                <img class="box-image" src="../../assets/images/pay/merit-4.png"/>
                <div class="box-title">快速部署</div>
                <div class="box-desc">
                  1、实施速度快，3-4周完成部署；<br/>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'product'
}
</script>

<style scoped lang="less">
  @import "../../assets/css/variable";
  .body-container {}
  .nav-container {
    width: @width-max;
    margin: 0 auto;
    padding: 26px 0;
    display: flex;
    align-items: center;
    .nava {
      padding: 15px;
      font-size: 16px;
      flex: 1;
      text-align: center;
    }
  }
</style>



// WEBPACK FOOTER //
// src/pages/product/product1.vue